import React, { useState, memo, useEffect } from 'react';
import { Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import BasicTable from '../BasicTable';


const distStr = (num) => {
    if (num >= 1000) {
        let rnd = Math.round(num / 100) / 10;
        return `${rnd} km`
    }
    else {
        return `${num} m`
    }
}


const AmenityDetail = ({ data }) => {

    const [places, setPlaces] = useState({});
    const header = ["Name", "Category", "Distance"];
    useEffect(() => {
        if (data != null && data.places != null) {
            let content = {};
            data.places.sort((a, b) => a.distanceM - b.distanceM).forEach(a => {
                console.log(a);
                (content[a.topLevelCategory] = content[a.topLevelCategory] ? content[a.topLevelCategory] : []).push([
                    a.name,
                    a.category,
                    distStr(a.distanceM)
                ]);
            });

            setPlaces(() => content);
        }
    }, [data]);


    return (
        <Paper>
            {places ? Object.keys(places).map(a => (
                <>
                    {console.log(a)}
                    <Typography variant="subtitle1" gutterBottom>{a}</Typography>
                    <BasicTable data={places[a]} header={header} />
                    <br />
                </>)
            ) : (<></>)}
        </Paper>
    );
}


export default memo(AmenityDetail);